<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-dropdown :text="$t('add-panel')" no-caret right class="text-left">
          <b-dropdown-item
            @click.prevent="toggleWidget"
          >
            {{ $t('energo-panel') }} <font-awesome-icon icon="check-circle" v-if="usesEenergoWidget" />
        </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import {mapState, mapMutations, mapGetters} from 'vuex';
import config from "@/config";
import axios from "axios";
import {SET_USER_DATA} from "@/store/mutation-types";

export default {
  name: 'DashboardCtxMenu',
  mixins: [
    BaseContextMenuMixin,
  ],
  computed: {
    ...mapGetters('user', [
      'getUserData',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    usesEenergoWidget() {
      return (this.getUserData.extra_settings || {}).useEnergoWidget || false;
    },
  },
  methods: {
    ...mapMutations('user', {
      updateUser: SET_USER_DATA,
    }),
    toggleWidget() {
      this.updateWidgets();
    },
    updateWidgets() {
      const url = new URL(
        config.ICOOL.API.USERS_ME_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      const currentSettings = this.getUserData.extra_settings || {};
      const data = { extra_settings: { ...currentSettings, useEnergoWidget: !this.usesEenergoWidget } };
      axios.patch(url, data)
        .then((response) => {
          this.updateUser(response.data);
        });
    },
  },
};
</script>

<style scoped>

</style>
